var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRCartSell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-cart-sell",
    x: 0.916,
    y: 0.131,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconR-cart-sell1",
    serifid: "iconR-cart-sell",
    d: "M6.547,17.143c-1.103,-0 -1.998,0.895 -1.998,1.998c-0,1.103 0.895,1.998 1.998,1.998c1.103,0 1.998,-0.895 1.998,-1.998c0,-1.103 -0.895,-1.998 -1.998,-1.998Zm11.384,-0.004c-1.103,0 -1.998,0.896 -1.998,1.998c0,1.103 0.895,1.999 1.998,1.999c1.103,-0 1.998,-0.896 1.998,-1.999c0,-1.102 -0.895,-1.998 -1.998,-1.998Zm-13.477,-12.008c-0,-0 -2.029,-0.012 -2.032,-0.012c-0.248,-0 -0.503,-0.248 -0.503,-0.521l-0,-0.468c-0,-0.267 0.258,-0.513 0.503,-0.513c0.002,-0 2.592,0.012 2.592,0.012c0,-0 0.526,-0.002 0.714,0.513c0.261,0.715 0.28,0.759 0.365,0.989c0.244,0 0.789,-0 2.21,-0c0.021,-0 0.042,0.008 0.057,0.023c0.015,0.015 0.023,0.035 0.023,0.056l-0,1.343c-0,0.044 -0.036,0.079 -0.08,0.079c0,0 -1.668,0.004 -1.668,0.004l3.228,8.869c0,-0 11.517,-2.669 11.517,-2.669c-0,-0 -0,-6.207 -0,-6.207l-1.356,0c-0.044,0 -0.08,-0.035 -0.08,-0.079l-0,-1.34c-0,-0.021 0.008,-0.041 0.023,-0.056c0.015,-0.015 0.036,-0.023 0.057,-0.023l1.884,0c0.528,-0 1.008,0.501 1.008,1c-0,0.012 -0.004,5.405 -0.004,7.004c0,0.87 -0.73,1.065 -0.937,1.12c-0,-0 -11.6,2.665 -12.461,2.862c-0.176,0.04 -0.303,0.01 -0.338,0.004c-0.386,-0.06 -0.503,-0.395 -0.523,-0.441c0,-0 -3.898,-10.715 -4.199,-11.549Zm9.551,-1.986c-0.049,0.009 -0.146,0.043 -0.146,0.043c-0.047,0.02 -0.088,0.042 -0.127,0.067c0,-0 -0.002,0.001 -0.005,0.003c-0.044,0.03 -0.083,0.062 -0.118,0.097l-2.465,2.465c-0.138,0.138 -0.224,0.329 -0.224,0.54c0,0.422 0.342,0.764 0.764,0.764c0.211,-0 0.401,-0.086 0.54,-0.224l1.162,-1.162l0,4.623c0,0.422 0.342,0.763 0.764,0.763c0.422,0 0.763,-0.341 0.763,-0.763l0,-4.623l1.163,1.162c0.138,0.138 0.329,0.224 0.54,0.224c0.421,-0 0.763,-0.342 0.763,-0.764c0,-0.211 -0.085,-0.402 -0.223,-0.54l-2.465,-2.465c-0.036,-0.035 -0.074,-0.067 -0.116,-0.095l-0.13,-0.07c0,-0 -0.011,-0.004 -0.015,-0.006c-0.037,-0.015 -0.137,-0.04 -0.14,-0.04c-0.042,-0.009 -0.091,-0.014 -0.14,-0.014c-0.05,0 -0.098,0.005 -0.145,0.015Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRCartSell);
export default __webpack_public_path__ + "static/media/iconR-cart-sell.9d94b0bb6cdc4e110c3fb3ba2abb46f5.svg";
export { ForwardRef as ReactComponent };